import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { _className } from '@nu-art/thunderstorm-frontend/index';
import { ColumnKey_MiddleColumn, PanelKey_Home, PanelKey_Spotlight } from '../../../_shared.js';
import { EndEncounterSurvey } from '@app/advisor-shared';
import { ICONS } from '@app/styles';
import { ModuleFE_Inbox } from '../../../modules/module-inbox/ModuleFE_Inbox.js';
import { ModuleFE_Advisor_AdvisorWizard, ModuleFE_EMInterface, ModuleFE_EncounterMetadata, Renderer_Survey } from '@app/advisor-frontend';
import './AdvisorMiniPanel_Spotlight.scss';
import { ModuleFE_Spotlight, spotlightMode_Disposition, spotlightMode_EditFindings, spotLightMode_PhysicianNotes, spotlightMode_ResolveOrder, spotlightMode_Support, spotlightMode_Survey, spotlightMode_Wizard } from '../../../modules/ModuleFE_Spotlight/index.js';
import { Component_DispositionForm } from '../../components/disposition/Component_DispositionForm.js';
import { Component_AdvisorWizard } from '../../components/advisor-wizard/Component_AdvisorWizard/Component_AdvisorWizard.js';
import { ModuleFE_AdvisorBoard } from '../../../_enum/advisor-board/index.js';
import { Renderer_Support } from '../../components/support/Renderer_Support.js';
import { AdvisorMiniPanel } from '../AdvisorMiniPanel/AdvisorMiniPanel.js';
import { DispoTypeToHeader } from '../../panels/AdvisorPanel_Spotlight/consts.js';
import { ModuleFE_AdvisorMini } from '../../../modules/ModuleFE_AdvisorMini.js';
import { Component_ResolveOrder } from '../../components/resolve-order/Component_ResolveOrder.js';
import { Component_EditFindings } from '../../components/edit-findings/Component_EditFindings.js';
import { Component_ReviewSummary } from '../../components/spotlight/Component_ReviewSummary/Component_ReviewSummary.js';
export class AdvisorMiniPanel_Spotlight extends AdvisorMiniPanel {
    static defaultProps = {
        panelKey: PanelKey_Spotlight,
        panelType: 'secondary',
    };
    //######################### Life Cycle #########################
    __onSpotlightMode = () => {
        const dataObj = ModuleFE_Spotlight.getSpotlightData();
        //Close Spotlight
        if (!dataObj) {
            // @ts-ignore
            this.state.data = undefined;
            return;
        }
        //Set data for spotlight
        this.setState({ data: dataObj });
    };
    componentDidUpdate(prevProps, prevState) {
        if (!prevState.data && !this.state.data)
            return;
        const columnState = ModuleFE_Spotlight.getSpotlightColumnState(this.state.data?.mode);
        const columnWidths = ModuleFE_Spotlight.getSpotlightColumnWidth(this.state.data?.mode);
        ModuleFE_AdvisorBoard.setColumnItems(ColumnKey_MiddleColumn, columnState);
        ModuleFE_AdvisorBoard.updateColumnsWidth(columnWidths);
        if (this.state.data)
            ModuleFE_AdvisorMini.openPanel(this.props.panelKey);
    }
    //######################### Logic #########################
    getPanelClass() {
        return _className(super.getPanelClass(), this.state.data?.mode);
    }
    //######################### Render - Header #########################
    renderHeader_Title = () => {
        const dataObj = this.state.data;
        switch (dataObj?.mode) {
            case spotLightMode_PhysicianNotes:
                return 'Physician Notes';
            case spotlightMode_Disposition: {
                const data = dataObj.data;
                return DispoTypeToHeader[data.dispositionType];
            }
            case spotlightMode_Wizard: {
                const data = dataObj.data;
                return ModuleFE_Advisor_AdvisorWizard.cache.unique(data.wizardId)?.label ?? 'Wizard Not Found';
            }
            case spotlightMode_Survey:
                return EndEncounterSurvey.label; // Again per Eitan decision on 4.11 this is a hard coded const
            case spotlightMode_Support:
                return 'Support';
            case spotlightMode_EditFindings:
                return 'Edit Findings';
        }
        return;
    };
    renderHeader_Tail = () => {
        return _jsx(ICONS.advisor_avn_close.component, { onClick: () => {
                ModuleFE_Inbox.setSelectedInboxItem(undefined);
                ModuleFE_AdvisorMini.openPanel(PanelKey_Home);
            } });
    };
    //######################### Render - Sub Header #########################
    renderSubHeader = () => {
        if (this.state.data?.mode !== spotlightMode_Survey)
            return;
        return EndEncounterSurvey.description;
    };
    //######################### Render - Content #########################
    _renderContent = (scrollRef) => {
        switch (this.state.data?.mode) {
            case spotlightMode_Wizard:
                return this.renderWizard(scrollRef);
            case spotLightMode_PhysicianNotes:
                return this.renderPhysicianNotes();
            case spotlightMode_Disposition:
                return this.renderDisposition(scrollRef);
            case spotlightMode_Survey:
                return this.renderSurvey(scrollRef);
            case spotlightMode_Support:
                return this.renderSupport(scrollRef);
            case spotlightMode_ResolveOrder:
                return this.renderResolveOrder(scrollRef);
            case spotlightMode_EditFindings:
                return this.renderEditFindings(scrollRef);
            default: {
                if (this.state.data)
                    this.logError(`Missing implementation for mode ${this.state.data.mode}`);
                return _jsx(_Fragment, {});
            }
        }
    };
    renderContent = () => _jsx(_Fragment, {});
    renderWizard = (scrollRef) => {
        if (!this.state.data)
            return _jsx(_Fragment, {});
        const data = this.state.data.data;
        return _jsx(Component_AdvisorWizard, { wizard: data.wizardId, contextType: data.contextType, contextId: data.contextId, scrollRef: scrollRef });
    };
    renderPhysicianNotes = () => {
        if (!this.state.data)
            return _jsx(_Fragment, {});
        const data = this.state.data.data;
        return _jsx(Component_ReviewSummary, { note: data.note });
    };
    renderDisposition = (scrollRef) => {
        if (!this.state.data)
            return _jsx(_Fragment, {});
        const data = this.state.data.data;
        return _jsx(Component_DispositionForm, { scrollRef: scrollRef, protocolId: data.protocolId, physicianNote: data.physicianNote, dispositionType: data.dispositionType });
    };
    renderSurvey = (scrollRef) => {
        if (!this.state.data)
            return _jsx(_Fragment, {});
        return _jsx(Renderer_Survey, { scrollRef: scrollRef, submitAction: async (payload) => {
                try {
                    await ModuleFE_EMInterface.vv1.advisorUtils.submitSurvey(payload).executeSync();
                    const dispoType = ModuleFE_EncounterMetadata.getEncounterMetadata()?.dispositionData.dispositionDecision;
                    if (!dispoType)
                        return;
                    ModuleFE_Spotlight.openDisposition({ dispositionType: dispoType }); // return to dispo form
                }
                catch (err) {
                    this.logError(err);
                }
            }, survey: EndEncounterSurvey });
    };
    renderSupport = (scrollRef) => {
        return _jsx(Renderer_Support, { scrollRef: scrollRef });
    };
    renderResolveOrder = (scrollRef) => {
        if (!this.state.data)
            return _jsx(_Fragment, {});
        const data = this.state.data.data;
        return _jsx(Component_ResolveOrder, { data: data, scrollRef: scrollRef });
    };
    renderEditFindings = (scrollRef) => {
        if (!this.state.data)
            return _jsx(_Fragment, {});
        const data = this.state.data.data;
        return _jsx(Component_EditFindings, { findings: data.findings });
    };
    //######################### Render - Footer #########################
    renderFooter = undefined;
}
//# sourceMappingURL=AdvisorMiniPanel_Spotlight.js.map